import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards/auth/auth.guard';
import { isModuleEnabledGuard } from '../../core/guards/subscription/is-module-enabled.guard';
import { SubscriptionActiveGuard } from '../../core/guards/subscription/subscription-active.guard';
import { maintenanceGuard } from '../../core/maintenance/maintenance.guard';
import { canEditProjectGuard } from './guards/can-edit-project.guard';

export const PROJECT_MANAGEMENT_ROUTES: Routes = [
  {
    path: 'project-management',
    loadComponent: () => import('./project-layout.component').then(m => m.ProjectLayoutComponent),
    canMatch: [maintenanceGuard],
    canActivate: [authGuard, SubscriptionActiveGuard, isModuleEnabledGuard],
    title: 'Gestion de projets',
    data: {
      moduleKey: 'projects_enable',
      pageHeader: {
        title: 'Gestion de projets',
        breadcrumb: 'Projets'
      }
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/project-list/project-list.component').then(m => m.ProjectListComponent),
        data: {
          pageHeader: {
            title: 'Mes projets',
            subtitle: 'Gestion et suivi de vos projets',
            icon: 'iconoirKanbanBoard'
          }
        }
      },
      {
        path: 'claude-connector',
        loadComponent: () => import('./pages/claude-connector/claude-connector.component').then(m => m.ClaudeConnectorComponent),
        data: {
          pageHeader: {
            title: 'Connecteur Claude',
            icon: 'iconoirPuzzle',
            breadcrumb: 'Connecteur Claude'
          }
        }
      },
      {
        path: ':id',
        loadComponent: () => import('./pages/project-detail/project-detail.component').then(m => m.ProjectDetailComponent),
        data: {
          pageHeader: {
            title: 'Détails du projet',
            icon: 'iconoirFolder',
            // Remplacé par la vue active (Board / Liste / Archives) par ProjectLayoutComponent.
            breadcrumb: 'Board'
          }
        }
      },
      {
        path: ':id/task/:taskId',
        loadComponent: () => import('./pages/task-detail/task-detail.component').then(m => m.TaskDetailComponent),
        data: {
          pageHeader: {
            title: 'Détails de la tâche',
            icon: 'iconoirClipboardCheck',
            breadcrumb: 'Tâche'
          }
        }
      },
      {
        path: ':id/edit',
        redirectTo: ':id/edit/informations',
        pathMatch: 'full'
      },
      {
        path: ':id/edit/:section',
        loadComponent: () => import('./pages/project-edit/project-edit.component').then(m => m.ProjectEditComponent),
        canActivate: [canEditProjectGuard],
        data: { pageHeader: { breadcrumb: 'Paramètres' } }
      },
      {
        path: ':id/team',
        loadComponent: () => import('./pages/project-team/project-team.component').then(m => m.ProjectTeamComponent),
        data: { pageHeader: { breadcrumb: 'Équipe' } }
      },
      {
        // L'ancienne vue « Groupes & Roadmap » est remplacée par la board unifiée
        // (Organisé par : Groupe) et sa dialog Roadmap. Redirection de compat pour
        // les anciens liens/favoris.
        path: ':id/groups',
        redirectTo: ':id'
      },
      {
        path: ':id/documents',
        loadComponent: () => import('./pages/project-documents/project-documents.component').then(m => m.ProjectDocumentsComponent),
        data: { pageHeader: { breadcrumb: 'Documents' } }
      },
      {
        path: ':id/reports',
        loadComponent: () => import('./pages/project-reports-list/project-reports-list.component').then(m => m.ProjectReportsListComponent),
        data: {
          pageHeader: {
            title: 'Rapports d\'activités',
            icon: 'iconoirStatsReport',
            breadcrumb: 'Rapports'
          }
        }
      },
      {
        path: ':id/reports/:reportId',
        loadComponent: () => import('./pages/project-report-detail/project-report-detail.component').then(m => m.ProjectReportDetailComponent),
        data: {
          pageHeader: {
            title: 'Détail du rapport',
            icon: 'iconoirStatsReport',
            breadcrumb: 'Rapport'
          }
        }
      },
      {
        path: 'access-denied',
        loadComponent: () => import('./pages/access-denied/access-denied.component').then(m => m.AccessDeniedComponent)
      }
    ]
  }
];